module.exports = __webpack_public_path__ + "asset/image-arrow-79cec6f2c6f0455d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/image/arrow.svg
// module id = O0OW
// module chunks = 3